import {Component, EventEmitter, Input, OnInit, Output, HostListener, ElementRef} from '@angular/core';
import {Router} from '@angular/router';
import {CountryModel} from '../../../models/localization-and-pricing/country.model';
import {NavigationModel} from '../../../models/localization-and-pricing/navigation.model';
import {UserModel} from '../../../models/authentication/user.model';
import {SchoolModel} from '../../../models/school/school.model';
import {StudentModel} from '../../../models/authentication/student.model';

@Component({
  selector: 'app-land-cover-header',
  templateUrl: './land-cover-header.component.html',
  styleUrls: ['./land-cover-header.component.css']
})
export class LandCoverHeaderComponent implements OnInit {

  @Input() headerBackgroundColor = 'rgba(0, 0, 0, 0)';
  @Input() headerTextLight = true;
  @Input() hidden = true;

  @Output() onBurgerClicked = new EventEmitter<void>();
  @Output() onGetStartedClicked = new EventEmitter<void>();
  @Output() onFeaturesClicked = new EventEmitter<void>();
  @Output() onSchoolsClicked = new EventEmitter<void>();
  @Output() onPricingClicked = new EventEmitter<void>();
  @Output() onResearchClicked = new EventEmitter<void>();

  CountryModel = CountryModel;

  constructor(private router: Router, private elementRef: ElementRef) {
  }

  ngOnInit() {
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Only handle clicks when the mobile menu is open
    if (!this.hidden) {
      const clickedInside = this.elementRef.nativeElement.contains(event.target);
      if (!clickedInside) {
        this.hidden = true;
      }
    }
  }

  getHeaderBgColor() {

    if (this.hidden) {
      return this.headerBackgroundColor;
    }

    return this.getBgColor();

  }

  getBgColor(): string {

    if (this.headerTextLight) {
      return 'rgba(0, 0, 0, 1)';
    }

    return 'rgba(255, 255, 255, 1)';

  }

  toggleBurgerMenu() {
    this.hidden = !this.hidden;
    this.onBurgerClicked.emit();
  }

  getStartedButtonTitle(): string {

    if (UserModel.getCurrent()) {
      return 'header.dashboard';
    }

    return 'header.getStarted';
  }

  handleGetStartedClick() {
    this.getStartedClicked();
    this.onGetStartedClicked.emit();
  }

  handleFeaturesClick() {
    this.navigateFeatures();
    this.onFeaturesClicked.emit();
    if (!this.hidden) {
      this.toggleBurgerMenu();
    }
  }

  handleSchoolsClick() {
    this.navigateSchools();
    this.onSchoolsClicked.emit();
    if (!this.hidden) {
      this.toggleBurgerMenu();
    }
  }

  handlePricingClick() {
    this.navigatePricing();
    this.onPricingClicked.emit();
    if (!this.hidden) {
      this.toggleBurgerMenu();
    }
  }

  handleResearchClick() {
    this.navigateResearch();
    this.onResearchClicked.emit();
    if (!this.hidden) {
      this.toggleBurgerMenu();
    }
  }

  // Navigation methods

  navigateFeatures() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['features', 'game']));
  }

  navigateSchools() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['schools']));
  }

  navigatePricing() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['pricing']));
  }

  navigateResearch() {
    this.router.navigate(NavigationModel.getHomeURLPaths(['research']));
  }

  login() {

    if (UserModel.isLoggedIn()) {

      if (UserModel.getCurrent().hasSchoolAccess() && SchoolModel.getCurrent() === null) {

        this.router.navigate(['selectschool']);

      } else {

        if (StudentModel.getCurrent()) {
          this.router.navigate(['platform', 'dash']);
        } else {
          this.router.navigate(['selectstudent']);
        }

      }

    } else {

      this.router.navigate(NavigationModel.getHomeURLPaths(['signin']));

    }

  }

  getStartedClicked() {

    if (UserModel.isLoggedIn()) {

      if (UserModel.getCurrent().hasSchoolAccess() && SchoolModel.getCurrent() === null) {

        this.router.navigate(['selectschool']);

      } else {

        if (StudentModel.getCurrent()) {
          this.router.navigate(['platform', 'dash']);
        } else {
          this.router.navigate(['selectstudent']);
        }

      }

    } else {

      this.router.navigate(NavigationModel.getHomeURLPaths(['signup']));

    }
  }
}
